import { render } from "./GenericalView.vue?vue&type=template&id=ac1f4c5c"
const script = {}
script.render = render

export default script